import React, { useState, useEffect } from 'react';
import { FaWhatsapp, FaTimes } from 'react-icons/fa';
import './WhatsAppFloatButton.css';

const WhatsAppFloatButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [hasTriggered, setHasTriggered] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Calculate when user reaches middle of page
      const scrollPosition = window.scrollY + window.innerHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const middleThreshold = pageHeight / 2;

      if (scrollPosition >= middleThreshold && !hasTriggered) {
        setIsOpen(true);
        setHasTriggered(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasTriggered]);

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  const handleSendMessage = () => {
    if (message.trim()) {
      const phoneNumber = '251911465364'; // Replace with your WhatsApp number
      const encodedMessage = encodeURIComponent(message);
      window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');
      setMessage('');
      setIsOpen(false);
    }
  };

  return (
    <div className={`whatsapp-float ${isOpen ? 'open' : ''}`}>
      {isOpen ? (
        <div className="whatsapp-chat-box">
          <div className="chat-header">
            <div className="chat-title">
              <FaWhatsapp className="whatsapp-icon" />
              <h3>Need help?</h3>
              <p>We're here to assist you!</p>
            </div>
            <button className="close-btn" onClick={toggleChat}>
              <FaTimes />
            </button>
          </div>
          <div className="chat-body">
            <p>Hi there! 👋</p>
            <p>How can we help you today?</p>
          </div>
          <div className="chat-footer">
            <input
              type="text"
              placeholder="Type your message..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
            />
            <button className="send-btn" onClick={handleSendMessage}>
              Send
            </button>
          </div>
        </div>
      ) : (
        <button className="whatsapp-button" onClick={toggleChat}>
          <FaWhatsapp className="whatsapp-icon" />
          <span className="tooltip">Chat with us</span>
        </button>
      )}
    </div>
  );
};

export default WhatsAppFloatButton;